"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
// Synthetic-only (no UI node): synthetic/busUploadToDatalake.ts adds one after
// each `reconciledBusTape` whose config sets `enableDataLake`. It carries no
// configuration: the task resolves the servicing cycle (facility, period, data
// tape) from the pipeline run.
exports.artifactType = 'busUploadToDatalake';
exports.NodeConfigSchema = zod_1.z
    .object({})
    .describe('Configuration for busUploadToDatalake node');
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
})
    .extend({
    externalFilename: zod_1.z.null(),
    type: zod_1.z.literal(exports.artifactType),
    loanProductSlug: zod_1.z.null(),
    creditFacilitySlug: zod_1.z.null(),
    configuration: exports.NodeConfigSchema,
})
    .describe('Schema for busUploadToDatalake DB record');
//# sourceMappingURL=node.js.map